import TourismMapScreen from '@/screens/TourismMap/TourismMapScreen';
import { AgriTourClicksFooter } from './AgriTourChrome';
import styles from './AgriTourMapScreen.module.css';

/** Public AgriTour entrepreneurs map — board 5098952022 (habait4u). */
export default function AgriTourEntrepreneursMapScreen() {
  return (
    <div className={styles.mapPage} dir="rtl" lang="he">
      <div className={styles.mapMain}>
        <TourismMapScreen
          fixedLayerId="agritour-entrepreneurs"
          title="מפת בקשות — קול קורא תיירות חקלאית"
          loadingLabel="טוען בקשות מ-Monday..."
          variant="agritour"
          syncPanelMode="geojson-only"
        />
      </div>
      <AgriTourClicksFooter compact showSupport={false} />
    </div>
  );
}
